import Vue from 'vue'
import Vuex from 'vuex'


import auth from './modules/auth'
import base from './modules/base'
import navigation from './modules/navigation'
import equipmentData from './modules/equipmentData'
import workRequests from './modules/workRequests'

import common from './modules/common'
import routerHelper from './modules/routerHelper'
import breadcrumbs from './modules/breadcrumbs'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    auth,
    base,
    navigation,
    equipmentData,
    workRequests,
    common,
    routerHelper,
    breadcrumbs,
  },
  state: {
    snackbarColor: '',
    snackbarText: '',
    navigationDrawer: null
  },
  getters: {},
  mutations: {
    setSnackbarData(state, payload) {
      state.snackbarColor = payload.color
      state.snackbarText = payload.text
    },
    setNavigationDrawer(state, payload) {
      state.navigationDrawer = payload
    },
    toggleNavigationDrawer(state) {
      state.navigationDrawer = !state.navigationDrawer
    }
  },
  actions: {}
})